/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-useless-escape */
const replaceSymbols = (value: string, isOutput: any, type?: string): string => {
  console.log(type, 'typeeeeeee')
  if (value?.trim() === '' || value?.trim()?.toLowerCase() === 'null') {
    return '';
  }
  if (value) {
    let val = value;
    const rangeMatch = value?.match(/(\[|\])\s*(-?[\d.]*)\s*to\s*(-?[\d.]*)\s*(\[|\])/) || [];

    const [fullvalue, firstBracket, firstValue, secondValue, secondBracket] = rangeMatch;



    // If value is a range
    if (rangeMatch?.length > 2) {
      val = `Between ${firstValue} (${firstBracket === '[' ? 'includes' : 'excludes'}) and ${secondValue}  (${secondBracket === '[' ? 'excludes' : 'includes'})`;
      return val;
    }

    const rangeMatchWithDots = value?.match(/(\[|\])\s*(-?[\d.]+)\s*\.\.\s*(-?[\d.]+)\s*(\[|\])/) || [];

    const [fullvalueDots, firstBracketDots, firstValueDots, secondValueDots, secondBracketDots] = rangeMatchWithDots;

    // If value is a range
    if (rangeMatchWithDots?.length > 2) {
      val = `Between ${firstValueDots} (${firstBracketDots === '[' ? 'includes' : 'excludes'}) and ${secondValueDots} (${secondBracketDots === '[' ? 'excludes' : 'includes'})`;
      return val;
    }

    // If value is just a number (possibly with whitespace)
    if (!isOutput && /^-?\d+(\.\d+)?$/.test(value.trim())) {
      return `Equal to ${value.trim()}`;
    }

    return val
      .replace(/>=/g, 'Greater than or equal to ')
      .replace(/<=/g, 'Less than or equal to ')
      .replace(/>/g, 'Greater than ')
      .replace(/</g, 'Less than ')
      .replace(/=/g, 'Equal to ')
      .replace(/not/g, 'should not match ')
      .replace(/"/g, '');
  }
  return '';
};

export default replaceSymbols;
